//桌位接口

import request from '../request';

//查询全部数据
export const reqGetAllData = () => request({ url:'/admin/table/all', method:'get' });

//新增桌位分组
export const reqAddData = (data) => request({ url:'/admin/table/save/group', method:'post', data });

//新增桌位明细
export const reqAddDetailData = (data) => request({ url:'/admin/table/save/detail', method:'post', data });

//删除桌位分组
export const reqDeleteGroupData = (id) => request({ url:`/admin/table/delete/group/${id}`, method:'delete'});

//删除桌位
export const reqDeleteTableData = (id) => request({ url:`/admin/table/delete/table/${id}`, method:'delete'});

//修改桌位分组名称
export const reqUpdateGroupData = (data) => request({ url:'/admin/table/update/group', method:'put', data });

//修改桌位明细
export const reqUpdateDetailData = (data) => request({ url:'/admin/table/update/detail', method:'put', data });
